import React, { useState } from 'react';
import Snackbar from '@mui/material/Snackbar';

import { Button, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import UPModal from './UPModal';

/**
 * Snackbar with cookies docs.
 */
export default function() {
  const [open, setOpen] = useState(!localStorage.getItem('cookiesSnackbar'));
  const [openMore, setOpenMore] = useState(false);
  const { t } = useTranslation();

  function handleClose() {
    localStorage.setItem('cookiesSnackbar', '1');
    setOpen(false);
  }

  function handleMore() {
    setOpen(false);
    setOpenMore(true);
  }

  function handleMoreClose() {
    localStorage.setItem('cookiesSnackbar', '1');
    setOpenMore(false);
  }

  return (
    <>
      <Snackbar
        open={open}
        anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
        action={[
          <Button key="ok" color="secondary" size="small" onClick={handleClose}>
            {t('ok')}
          </Button>,
          <Button
            key="more"
            color="secondary"
            size="small"
            onClick={handleMore}
          >
            {t('more')}
          </Button>
        ]}
        message="Наш сайт использует файлы cookies и собирает пользовательские данные в целях обеспечения Вашего взаимодействия с сайтом, сбора статистики и проведения ретаргетинга. Продолжая использовать сайт, Вы даете согласие на обработку указанных данных."
      />
      <UPModal open={openMore} onClose={handleMoreClose}>
        <Typography variant="h6" id="modal-title">
          Уведомление об использовании файлов cookies и сервисов web-аналитики
        </Typography>
        <Typography variant="subtitle1">
          1. ООО «НАЗВАНИЕ» уведомляет Вас о том, что сайт НАЗВАНИЕ САЙТА (далее
          – «Сайт») использует файлы cookies и сервисы web-аналитики
          Яндекс.Метрика Google.Analytics
        </Typography>
        <Typography variant="subtitle1">
          2. Файлы cookies– это небольшие фрагменты данных, которые посылаются
          сайтом на устройство пользователя при посещении Сайта и хранится в
          браузере устройства. Файлы cookies возвращаются на наш Сайт при каждом
          следующем посещении или на сторонние сайты, которые распознают файлы
          cookies.
        </Typography>
        <Typography variant="subtitle1">
          Файлы cookies позволяют Сайту распознавать устройство пользователя (но
          не идентифицировать самого пользователя) при повторных посещениях,
          запоминать предпочтения пользователя, улучшать его взаимодействие с
          сайтом и настраивать рекламу в соответствии с интересами пользователя.
        </Typography>
        <Typography variant="subtitle1">
          3. Сайт использует сервис веб-аналитики Яндекс.Метрика,
          предоставляемый ООО «Яндекс», 119021, Россия, Москва, ул. Л. Толстого,
          16 (далее – «Яндекс»)
        </Typography>
        <Typography variant="subtitle1">
          Информация об использовании Сайта, собранная с помощью файлов cookies,
          установленных Яндексом, будет передаваться Яндексу и храниться на
          сервере Яндекса в ЕС и Российской Федерации. Яндекс будет обрабатывать
          эту информацию для оценки использования вами Сайта, составления для
          ООО «НАЗВАНИЕ» отчетов о деятельности Сайта, и предоставления других
          услуг. Яндекс обрабатывает эту информацию в порядке, установленном в
          условиях использования сервиса Яндекс.Метрика, ознакомиться с которыми
          Вы можете по ссылке https://yandex.ru/legal/metrica_termsofuse/
        </Typography>
        <Typography variant="subtitle1">
          Чтобы установить блокировщик Яндекс.Метрики, пройдите по ссылке
          .https://yandex.ru/support/metrika/general/opt-out.html
        </Typography>
        <Typography variant="subtitle1">
          Обращаем Ваше внимание, что установка блокировщика может негативно
          повлиять на работу некоторых функций Сайта
        </Typography>
        <Typography variant="subtitle1">
          Используя этот Сайт, Вы соглашаетесь на описанную выше обработку
          данных о Вас Яндексом
        </Typography>
        <Typography variant="subtitle1">
          4. Сайт использует сервис веб-аналитики Google.Analytics,
          предоставляемый компанией GoogleLLC, 1600 Amphitheatre Parkway,
          Mountain View, CA 94043, United States(далее – «Google»)
        </Typography>
        <Typography variant="subtitle1">
          Информация об использовании Сайта, собранная с помощью файлов cookies,
          установленных Google, будет передаваться Google и храниться на сервере
          Google в США. Google будет обрабатывать эту информацию для оценки
          использования вами Сайта, составления для ООО «НАЗВАНИЕ» отчетов о
          деятельности Сайта, и предоставления других услуг.
        </Typography>
        <Typography variant="subtitle1">
          С информацией для посетителей сайтов и приложений, использующих сервис
          Google.Analytics, вы можете ознакомиться по ссылке
          https://support.google.com/analytics/answer/6004245?hl=ru
        </Typography>
        <Typography variant="subtitle1">
          Чтобы установить блокировщик сервиса Google.Analytics, пройдите по
          ссылке https://tools.google.com/dlpage/gaoptout
        </Typography>
        <Typography variant="subtitle1">
          Обращаем Ваше внимание, что установка блокировщика может негативно
          повлиять на работу некоторых функций Сайта
        </Typography>
        <Typography variant="subtitle1">
          Используя этот Сайт, Вы соглашаетесь на описанную выше обработку
          данных о Вас компанией Google LLC
        </Typography>
        <Typography variant="subtitle1">
          5. Большинство браузеров принимает файлы cookiesпо умолчанию. Вы
          вправе принять или отклонить передачу файлов cookiesна Ваше устройство
          в любое время, изменив настройки Вашего браузера. Вы можете
          контролировать и удалять файлы cookiesпо своему усмотрению. Подробную
          информацию об этом Вы найдете на сайте aboutcookies.org
        </Typography>
        <Typography variant="subtitle1">
          Используя этот Сайт, Вы соглашаетесь на обработку файлов cookiesна
          условиях, изложенных в настоящем Уведомлении
        </Typography>
      </UPModal>
    </>
  );
}
